import { Set, Record } from 'immutable';
import {
  RawSubmittalCategory,
  SubmittalCategory,
} from 'records/SubmittalCategory';
import { RawSubmittalStatus, SubmittalStatus } from 'records/SubmittalStatus';

export interface RawSubmittalQuery {
  submittalNumbers: string[];
  statuses: RawSubmittalStatus[];
  categories: RawSubmittalCategory[];
  dueFromSub: number;
  dueFromReviewer: number;
  sortDirection: 'ascending' | 'descending';
  search: string;
  sortField: string;
}

export interface SubmittalQueryData {
  submittalNumbers: Set<string>;
  statuses: Set<SubmittalStatus>;
  categories: Set<SubmittalCategory>;
  dueFromSub: number;
  dueFromReviewer: number;
  sortDirection: 'ascending' | 'descending';
  search: string;
  sortField: string;
}

const defaultValues: SubmittalQueryData = {
  submittalNumbers: Set<string>(),
  statuses: Set<SubmittalStatus>(),
  categories: Set<SubmittalCategory>(),
  dueFromSub: 0,
  dueFromReviewer: 0,
  sortDirection: 'descending',
  search: '',
  sortField: 'submittalNumber',
};

export const SubmittalQueryFactory = Record(defaultValues, 'SubmittalQuery');

export class SubmittalQuery extends SubmittalQueryFactory {
  static deserialize(rawSubmittalQuery: RawSubmittalQuery): SubmittalQuery {
    return new SubmittalQuery({
      statuses: Set<SubmittalStatus>(
        rawSubmittalQuery.statuses.map((s) => SubmittalStatus.deserialize(s))
      ),
      submittalNumbers: Set<string>(rawSubmittalQuery.submittalNumbers),
      categories: Set<SubmittalCategory>(
        rawSubmittalQuery.categories.map((s) =>
          SubmittalCategory.deserialize(s)
        )
      ),
      dueFromSub: rawSubmittalQuery.dueFromSub,
      dueFromReviewer: rawSubmittalQuery.dueFromReviewer,
      sortDirection: rawSubmittalQuery.sortDirection,
      search: rawSubmittalQuery.search,
      sortField: rawSubmittalQuery.sortField,
    });
  }

  serialize(): RawSubmittalQuery {
    return this.toJS();
  }
}

export function serializeSubmittalQuery(
  item: SubmittalQuery
): RawSubmittalQuery {
  return item.toJS();
}
